"use client";

import { useEffect } from "react"
import NextError from "next/error"
import * as Sentry from "@sentry/nextjs"

export default function GlobalError({error}) {

    useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return (
        <main className="mt-0 flex flex-col items-center justify-center absolute inset-0 z-10 bg-black text-white w-full h-full">
            <NextError statusCode={0} />
        </main>
    )
}